import { apiProxyRequest } from "Api/apiProxyRequest";

import type { PaymentSourcesResponse } from "../types";

export const getProfilePaymentSourcesRequest = (billingProfileId: string) => {
  return apiProxyRequest<PaymentSourcesResponse>(
    `/billing/profiles/${billingProfileId}/payment-source`
  );
};
